type ProductionDeclarationSendDefaultMessageParams = {
  poNumber: string;
  supplierName: string;
  supplierPortalLink: string;
};

export function getProductionDeclarationApproveDefaultMessage({
  poNumber,
  supplierName,
}: ProductionDeclarationSendDefaultMessageParams): string {
  return `Dear ${supplierName},

We are pleased to inform you that your EUDR Due Diligence statement of the PO n°${poNumber} has been reviewed and accepted.
You may now proceed with mass production of the PO n°${poNumber}.

Please ensure that:
The actual production and supply chain remain consistent with the information and documents submitted via the EUDR Information and Evidence portal.
Any future changes to the supply chain or materials are communicated to Miliboo in advance and promptly updated in the portal.

If you have any questions, please contact us at qualite@miliboo.com. Thank you for your cooperation and support.

Kind regards,
Miliboo Quality team`;
}

export function getProductionDeclarationRefuseDefaultMessage({
  poNumber,
  supplierName,
  supplierPortalLink,
}: ProductionDeclarationSendDefaultMessageParams): string {
  return `Dear ${supplierName},

Following our review of your submission of statement of the PO n°${poNumber} in the Miliboo EUDR Information and Evidence Portal, we identified information that must be updated or corrected.
Please complete the required updates within 5 days of receiving this message.

Required actions:
Link to the portal: ${supplierPortalLink}
Update the requested supply chain information and supporting documents
Ensure the information reflects the actual supply chain stages
Verify all supplier and customer details (name, postal address, and email)

If the updates are not completed within 5 days, this may delay approval of your submission and affect EUDR compliance.

If you need assistance, please contact qualite@miliboo.com.

Thank you for your prompt cooperation.

Kind regards,
Miliboo Quality team`;
}
